export default __webpack_public_path__ + "static/hex-f5f8e68ac54253793f03f9ac2a4984a7.png";